import { useMount, useReactive, useSetState } from "ahooks";
import React, { useState } from "react";
import Cookie from "js-cookie";
import AdScrollRefresh from "./AdScrollRefresh";

const setTarget = (googletag, target) => {
  googletag.pubads().enableSingleRequest();
  googletag.enableServices();

  if (Cookie.get("adtest") == "true") {
    googletag.pubads().setTargeting("debug", "1");
  }

  if (Array.isArray(target)) {
    googletag.pubads().setTargeting(...target);
  } else {
    let nc_user_brand = JSON.parse(localStorage.getItem("nc_user_brand") as string);
    let nc_user_kind = JSON.parse(localStorage.getItem("nc_user_kind") as string);
    let nc_auto_type = JSON.parse(localStorage.getItem("nc_auto_type") as string);
    let nc_brand = (localStorage.getItem("nc_brand") as string) || "";
    let nc_kind = (localStorage.getItem("nc_kind") as string) || "";

    let buycar_stage = localStorage.getItem("buycar_stage") || "";

    let price = localStorage.getItem("nc_price");

    if (!!price) {
      let priceRange = price.split(",");
      googletag.pubads().setTargeting("nc_price", priceRange);
    }

    googletag.pubads().setTargeting("nc_user_brand", nc_user_brand);
    googletag.pubads().setTargeting("nc_user_kind", nc_user_kind);
    googletag.pubads().setTargeting("nc_auto_type", nc_auto_type);
    googletag.pubads().setTargeting("buycar_stage", buycar_stage);
    googletag.pubads().setTargeting("nc_brand", nc_brand);
    googletag.pubads().setTargeting("nc_kind", nc_kind);
  }
};

const adRefresh = (solt) => {
  const googletag = (window.googletag = window.googletag || { cmd: [] });
  googletag?.cmd?.push(() => {
    let tags = googletag.pubads().getSlots();

    tags.map(function (value, key, arr) {
      if (value.getAdUnitPath() == solt) {
        googletag.pubads().refresh([tags[key]]);
      }
    });
  });
};

const AdIframe: React.FC<{
  onCallBack?: any;
  slot: any;
  target?: string;
  size: any;
  width: string | number;
  height: string | number;
  className?: string;
  showLinkImage?: boolean;
  styles?: React.CSSProperties;
}> = ({ onCallBack, slot, target, size, showLinkImage = false, width, height, className, styles }) => {
  const [state, setState] = useSetState({ isEmpty: true, isAd: false });
  const [_event, setEvent] = useState<any>({});
  const { isEmpty, isAd } = state;

  const addEventListener = () => {
    const googletag = (window.googletag = window.googletag || { cmd: [] });
    googletag?.cmd?.push(() => {
      googletag.pubads()?.addEventListener("slotRenderEnded", (e) => slotRenderEnded(e));
    });
  };

  const slotRenderEnded = (event: any) => {
    if (event.slot?.getAdUnitPath() === slot && !event.isEmpty && Object.keys(_event)?.length === 0) {
      const _html = event.slot?.getHtml();
      setState({ isEmpty: false });

      try {
        const matchResult = _html.match(/---(.*)---/);
        const nextEvent = matchResult && matchResult[1] ? JSON.parse(matchResult[1]) : {};
        setEvent(nextEvent);
        onCallBack?.(nextEvent, event);
      } catch (e) {
        console.log(`${event.slot.getAdUnitPath()}:沒有廣告格式`);
      }
    }
  };

  const display = () => {
    const googletag = (window.googletag = window.googletag || { cmd: [] });
    googletag?.cmd?.push(() => {
      try {
        setTarget(window.googletag, target);
        googletag.defineSlot(slot, size, slot).addService(googletag.pubads());

        googletag.display(slot);
      } catch (e) {
        adRefresh(slot);
      }
    });
  };

  useMount(() => {
    setState({ isAd: true });
    setTimeout(() => {
      if (typeof onCallBack === "function") {
        addEventListener();
      }
      display();
    }, 0);
  });

  return <>{isAd && <div style={{ height: showLinkImage ? 0 : isEmpty ? 0 : `${height}px` }} id={slot}></div>}</>;
};

const AdIframeImage: React.FC<{
  slot: any;
  target?: string;
  width: string | number;
  height: string | number;
  size: any;
  className?: string;
  styles?: React.CSSProperties;
  imgStyles?: React.CSSProperties;
  refresh?: any;
  children?: React.ReactNode;
  supportPosition?: "left-top";
}> = ({
  slot,
  target,
  width,
  height,
  size,
  className,
  refresh = true,
  styles = {},
  children,
  imgStyles = {},
  supportPosition = "left-top",
}) => {
  const paramsReactive = useReactive({
    data: [],
    activeData: {},
    navStatus: false,
    key: "",
    adValue: {
      image: "",
      img: "",
      link: "",
    },
    showSupport: false,
  });
  const { adValue } = paramsReactive;

  const supportPositionStyle = {
    "left-top": {
      left: 0,
      top: 0,
    },
  };

  return (
    <>
      <AdScrollRefresh slot={slot} refresh={refresh}>
        <AdIframe
          onCallBack={(value) => {
            paramsReactive.adValue = value;
            paramsReactive.showSupport = value.business === "yes";
          }}
          size={size}
          className={className}
          styles={styles}
          slot={slot}
          width={0}
          height={adValue.link ? 0 : height}
          target={target}
          showLinkImage={!!adValue.link}
        />
        {!!adValue.link && (
          <div
            style={{
              width: "100%",
              height: typeof height === "number" ? height + "px" : height,
              marginBottom: styles?.marginBottom ? styles?.marginBottom : "0",
              marginTop: styles?.marginTop ? styles?.marginTop : "0",
            }}
          >
            {paramsReactive.showSupport && (
              <img
                style={{
                  width: "28px",
                  height: "16px",
                  objectFit: "cover",
                  position: "absolute",
                  zIndex: 1,
                  ...supportPositionStyle[supportPosition],
                }}
                src='https://photo.8891.com.tw/2024/11/08/1731055920848515.png'
                alt='logo'
              />
            )}
            <a
              style={{
                width: "100%",
                height: typeof height === "number" ? height + "px" : height,
                display: "block",
                position: "absolute",
                top: 0,
                left: 0,
              }}
              href={adValue.link}
              target='_blank'
            >
              <img
                style={{ width: "100%", height: "100%", objectFit: "cover", ...imgStyles }}
                src={adValue.img}
                alt={adValue.link}
              />
            </a>
          </div>
        )}
        {React.isValidElement(children) && React.cloneElement(children)}
      </AdScrollRefresh>
    </>
  );
};

export default AdIframeImage;
